import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ConfigurationService } from "../../providers/configuration/configuration.service";

@Injectable()
export class IDPService {
  private dataUrl: string;

  constructor(
    private http: HttpClient,
    private configurationService: ConfigurationService
  ) {
    this.dataUrl = configurationService.getConfig().apiUrl;
  }

  clearSession() {
    //clear session from backend services
    return this.http.get(`${this.dataUrl}/idp-logout`);
  }
}



// WEBPACK FOOTER //
// ./src/app/auth/idp.service.ts